import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/commercialsolution`;

export const MARKETING_OFFER_TYPE = {
  REFUND_BY_WIRE_TRANSFER: 'RefundByWireTransfer',
  REFUND_ON_PAYMENT_METHOD: 'RefundOnPaymentMethod',
  GIFT_CARD: 'GiftCard',
  VOUCHER: 'Voucher',
  EXCHANGE_ON_SELLER_STOCK: 'ExchangeOnSellerStock',
  CREDIT_NOTE: 'CreditNote',
  NOT_SET: 'NotSet',
  DIGITAL_GIFT_CARD: 'DigitalGiftCard',
  CASH_REGISTER: 'CashRegister',
  CHECK: 'Check',
  LOYALTY_CARD: 'LoyaltyCard',
  LENDER: 'Lender',
  PAYMENT_SERVICE: 'PaymentService',
  FRANCHISED_CASH_REGISTER: 'FranchisedCashRegister',
  OTHER_REFUND: 'OtherRefund',
} as const;
export type MarketingOfferType =
  (typeof MARKETING_OFFER_TYPE)[keyof typeof MARKETING_OFFER_TYPE];

export const COMMERCIAL_SOLUTION_TYPE = {
  CURRENCY: 'Currency',
  PERCENTAGE: 'Percentage',
} as const;
export type CommercialSolutionType =
  (typeof COMMERCIAL_SOLUTION_TYPE)[keyof typeof COMMERCIAL_SOLUTION_TYPE];

export interface SetCommercialSolutionCommandPayload {
  fileId: string;
  marketingOfferType?: MarketingOfferType;
  solutionType?: CommercialSolutionType;
  percentageValue?: number;
  refundedAmount?: number;
}

export const setCommercialSolutionRequest = ({
  fileId,
  ...json
}: SetCommercialSolutionCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.PUT, json },
});

async function setCommercialSolutionCommand(
  payload: SetCommercialSolutionCommandPayload,
): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      setCommercialSolutionRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default setCommercialSolutionCommand;
